import { memo } from 'react';
import styled from 'styled-components';

const getIcon = (type, color) => {
  const fillColor = encodeURIComponent(color);

  const icons = {
    figures: `url("data:image/svg+xml;charset=utf-8,%3Csvg fill='${fillColor}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 28'%3E%3Cpath d='M18.766 12.25c2.203 0.641 5.234 2.812 5.234 9.922 0 3.219-2.391 5.828-5.328 5.828h-13.344c-2.938 0-5.328-2.609-5.328-5.828 0-7.109 3.031-9.281 5.234-9.922-0.781-1.234-1.234-2.688-1.234-4.25 0-4.406 3.594-8 8-8s8 3.594 8 8c0 1.563-0.453 3.016-1.234 4.25zM12 2c-3.313 0-6 2.688-6 6s2.688 6 6 6 6-2.688 6-6-2.688-6-6-6zM18.672 26c1.828 0 3.328-1.703 3.328-3.828 0-4.922-1.656-8-4.75-8.156-1.406 1.234-3.234 1.984-5.25 1.984s-3.844-0.75-5.25-1.984c-3.094 0.156-4.75 3.234-4.75 8.156 0 2.125 1.5 3.828 3.328 3.828h13.344z'/%3E%3C/svg%3E")`,
    parts: `url("data:image/svg+xml;charset=utf-8,%3Csvg fill='${fillColor}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M18.961 6.828l-6.961 4.027-6.961-4.027 6.456-3.689c0.112-0.064 0.232-0.105 0.355-0.124 0.218-0.034 0.445 0.003 0.654 0.124zM11.526 22.961c0.141 0.076 0.303 0.119 0.474 0.119 0.173 0 0.336-0.044 0.478-0.121 0.356-0.058 0.701-0.18 1.017-0.36l7.001-4.001c0.618-0.357 1.060-0.897 1.299-1.514 0.133-0.342 0.202-0.707 0.205-1.084v-8c0-0.478-0.113-0.931-0.314-1.334-0.022-0.071-0.052-0.14-0.091-0.207-0.046-0.079-0.1-0.149-0.162-0.21-0.031-0.043-0.064-0.086-0.097-0.127-0.23-0.286-0.512-0.528-0.831-0.715l-7.009-4.005c-0.61-0.352-1.3-0.465-1.954-0.364-0.363 0.057-0.715 0.179-1.037 0.363l-7.001 4.001c-0.383 0.221-0.699 0.513-0.941 0.85-0.060 0.060-0.114 0.13-0.159 0.207-0.039 0.068-0.070 0.138-0.092 0.21-0.040 0.080-0.076 0.163-0.108 0.246-0.132 0.343-0.201 0.708-0.204 1.078v8.007c0.001 0.71 0.248 1.363 0.664 1.878 0.23 0.286 0.512 0.528 0.831 0.715l7.009 4.005c0.324 0.187 0.67 0.307 1.022 0.362zM11 12.587v7.991l-6.495-3.711c-0.111-0.065-0.207-0.148-0.285-0.245-0.139-0.172-0.22-0.386-0.22-0.622v-7.462zM13 20.578v-7.991l7-4.049v7.462c-0.001 0.121-0.025 0.246-0.070 0.362-0.080 0.206-0.225 0.384-0.426 0.5z'/%3E%3C/svg%3E")`,
    reference: `url("data:image/svg+xml;charset=utf-8,%3Csvg fill='${fillColor}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 28 28'%3E%3Cpath d='M15.484 16l1-4h-3.969l-1 4h3.969zM27.484 8.125l-0.875 3.5c-0.063 0.219-0.25 0.375-0.484 0.375h-5.109l-1 4h4.859c0.156 0 0.297 0.078 0.391 0.187 0.094 0.125 0.141 0.281 0.094 0.438l-0.875 3.5c-0.047 0.219-0.25 0.375-0.484 0.375h-5.109l-1.266 5.125c-0.063 0.219-0.266 0.375-0.484 0.375h-3.5c-0.156 0-0.313-0.078-0.406-0.187-0.094-0.125-0.125-0.281-0.094-0.438l1.219-4.875h-3.969l-1.266 5.125c-0.063 0.219-0.266 0.375-0.484 0.375h-3.516c-0.141 0-0.297-0.078-0.391-0.187-0.094-0.125-0.125-0.281-0.094-0.438l1.219-4.875h-4.859c-0.156 0-0.297-0.078-0.391-0.187-0.094-0.125-0.125-0.281-0.094-0.438l0.875-3.5c0.063-0.219 0.25-0.375 0.484-0.375h5.109l1-4h-4.859c-0.156 0-0.297-0.078-0.391-0.187-0.094-0.125-0.141-0.281-0.094-0.438l0.875-3.5c0.047-0.219 0.25-0.375 0.484-0.375h5.109l1.266-5.125c0.063-0.219 0.266-0.375 0.5-0.375h3.5c0.141 0 0.297 0.078 0.391 0.187 0.094 0.125 0.125 0.281 0.094 0.438l-1.219 4.875h3.969l1.266-5.125c0.063-0.219 0.266-0.375 0.5-0.375h3.5c0.141 0 0.297 0.078 0.391 0.187 0.094 0.125 0.125 0.281 0.094 0.438l-1.219 4.875h4.859c0.156 0 0.297 0.078 0.391 0.187 0.094 0.125 0.125 0.281 0.094 0.438z'/%3E%3C/svg%3E")`,
    release: `url("data:image/svg+xml;charset=utf-8,%3Csvg fill='${fillColor}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26 28'%3E%3Cpath d='M2 26h4.5v-4.5h-4.5v4.5zM7.5 26h5v-4.5h-5v4.5zM2 20.5h4.5v-5h-4.5v5zM7.5 20.5h5v-5h-5v5zM2 14.5h4.5v-4.5h-4.5v4.5zM13.5 26h5v-4.5h-5v4.5zM7.5 14.5h5v-4.5h-5v4.5zM19.5 26h4.5v-4.5h-4.5v4.5zM13.5 20.5h5v-5h-5v5zM8 7v-4.5c0-0.266-0.234-0.5-0.5-0.5h-1c-0.266 0-0.5 0.234-0.5 0.5v4.5c0 0.266 0.234 0.5 0.5 0.5h1c0.266 0 0.5-0.234 0.5-0.5zM19.5 20.5h4.5v-5h-4.5v5zM13.5 14.5h5v-4.5h-5v4.5zM19.5 14.5h4.5v-4.5h-4.5v4.5zM20 7v-4.5c0-0.266-0.234-0.5-0.5-0.5h-1c-0.266 0-0.5 0.234-0.5 0.5v4.5c0 0.266 0.234 0.5 0.5 0.5h1c0.266 0 0.5-0.234 0.5-0.5zM26 6v20c0 1.094-0.906 2-2 2h-22c-1.094 0-2-0.906-2-2v-20c0-1.094 0.906-2 2-2h2v-1.5c0-1.375 1.125-2.5 2.5-2.5h1c1.375 0 2.5 1.125 2.5 2.5v1.5h6v-1.5c0-1.375 1.125-2.5 2.5-2.5h1c1.375 0 2.5 1.125 2.5 2.5v1.5h2c1.094 0 2 0.906 2 2z'/%3E%3C/svg%3E")`,
  };

  return icons[type];
};

const Item = styled.div<{ type: string }>`
  background: none center 10px no-repeat;
  background-image: ${(props) =>
    getIcon(props.type, props.theme.colors?.grey2)};
  background-size: 30px 30px;
  border: dotted var(--theme-color-grey2);
  border-width: 0 2px 0 0;
  display: flex;
  flex-direction: column;
  font-size: 1.2em;
  justify-content: flex-end;
  margin: 0 5px 0 0;
  padding: 50px 5px 1rem 0;
  text-align: center;

  &:nth-child(1),
  &:nth-child(2) {
    border-width: 0 2px 2px 0;
  }

  &:nth-child(2n) {
    border-right-width: 0;
  }

  @media ${(props) => props.theme.breakpoints.md} {
    border-width: 0 2px 0 0 !important;

    &:last-child {
      border-width: 0;
    }
  }
`;

const Title = styled.strong`
  text-transform: capitalize;
`;

type ProductMetaItemProps = {
  formatNumber?: boolean;
  title: string;
  type: string;
  value: string;
};

const ProductMetaItem = ({
  formatNumber,
  title,
  type,
  value,
}: ProductMetaItemProps) => {
  return (
    <Item type={type}>
      <Title>{title}</Title>
      {formatNumber ? new Intl.NumberFormat().format(parseFloat(value)) : value}
    </Item>
  );
};

export default memo(ProductMetaItem);
